import React from 'react';
export function FinalCTA() {
  return <section className="bg-primary py-24 text-center" data-id="element-22">
      <div className="max-w-4xl mx-auto px-4" data-id="element-23">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-24">
          Esta noche puede ser diferente.
        </h2>

        <p className="text-accent italic text-xl md:text-2xl mb-12" data-id="element-25">
          14 días. Un método. El sueño que mereces.
        </p>

        <button className="w-full sm:w-auto bg-transparent border-2 border-accent text-accent hover:bg-accent hover:text-primary px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-10" data-id="element-26">
          QUIERO MI GUÍA AHORA — $9.99 &rarr;
        </button>

        <div className="flex flex-wrap justify-center items-center gap-6 text-white font-bold" data-id="element-27">
          <div className="flex items-center gap-2" data-id="element-28">
            <span className="text-xl" data-id="element-29">🔒</span> Pago Seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-30">
            <span className="text-xl" data-id="element-31">📥</span> Descarga Inmediata
          </div>
          <div className="flex items-center gap-2" data-id="element-32">
            <span className="text-xl" data-id="element-33">🌙</span> Sin Pastillas
          </div>
        </div>

        <p className="mt-10 text-sm md:text-base text-white/70 italic max-w-2xl mx-auto leading-relaxed" data-id="element-34">
          Cada afirmación está respaldada por estudios publicados en revistas
          científicas internacionales — las referencias están incluidas al final
          de la guía.
        </p>
      </div>
    </section>;
}